<template>
  <div
    v-text="msg"
    class="text-center bg-green-50 px-4 py-2 my-4 text-green-700 border border-green-300 rounded-lg"
  ></div>
</template>
<script>
export default {
  props: ["msg"],
  data() {
    return {};
  },
};
</script>